export class MoleculePanelEditRowTableBundleBackupsAutoComponent {
    public templateUrl = require('./bundle-backups-auto.html?external');
}
